/* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides*/
import type { FC } from 'react';
import React from 'react';
import formatRelative from 'date-fns/formatRelative';

import Tooltip from '@atlaskit/tooltip/Tooltip';
import BitbucketBranchesIcon from '@atlaskit/icon/core/branch';

import { exitBranchFn } from '@confluence/atlassian-internal-help-items';
import { Cookies } from '@confluence/cookies';

import { ConfigurationButton } from './ConfigurationButton.tsx';

export const BranchDeployLogo: FC = () => {
	const { frontendVersion, buildDate } = getBuildInfo();
	const hasBifrostOverride = Cookies.get('bifrost-override');
	const tooltipMessage = `Click to exit branch deploy. Using ${hasBifrostOverride ? 'Bifrost' : ''} branch deploy ${frontendVersion}.\nBuilt ${buildDate}.`;
	return (
		<ConfigurationButton data-testid="app-navigation-wordmark-branch" onClick={exitBranchFn}>
			<Tooltip content={tooltipMessage} css={{ whiteSpace: 'pre-line' }}>
				<BitbucketBranchesIcon label="Exit branch" />
			</Tooltip>
		</ConfigurationButton>
	);
};

const getBuildInfo = () => {
	const info = {
		frontendVersion: '',
		buildDate: '',
	};

	// Needs to be ts-ignore for now since it won't throw an error
	// until we move to project references
	// @ts-ignore tsc compile cannot find on global window object
	if (!window || !window.__buildInfo) {
		return info;
	}

	// Needs to be ts-ignore for now since it won't throw an error
	// until we move to project references
	// @ts-ignore tsc compile cannot find on global window object
	const buildInfo = window.__buildInfo;
	if (buildInfo.FRONTEND_VERSION) {
		info.frontendVersion = buildInfo.FRONTEND_VERSION.replace(/^CLASSIC-/, '');
	}
	if (buildInfo.BUILD_DATE) {
		info.buildDate = formatRelative(buildInfo.BUILD_DATE, Date.now());
	}

	return info;
};
